import React from "react";
import { useNavigate } from "react-router-dom";

interface U2000NotFoundProps {}

const U2000NotFound: React.FC<U2000NotFoundProps> = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg border border-gray-200 p-8 text-center animate-fade-in">
        {/* Icône 404 moderne */}
        <div className="w-20 h-20 mx-auto mb-6 bg-red-100 rounded-full flex items-center justify-center">
          <span className="text-3xl font-bold text-red-600">404</span>
        </div>

        {/* Message d'erreur */}
        <h1 className="text-2xl font-bold text-gray-900 mb-3">Page Non Trouvée</h1>
        <p className="text-gray-600 mb-8">Désolé, la page que vous cherchez n'existe pas ou a été déplacée.</p>

        {/* Bouton de retour moderne */}
        <button
          className="w-full h-[46px] bg-primary-600 text-white rounded-lg font-medium transition-all duration-200 
                     hover:bg-primary-700 focus:outline-hidden focus:ring-2 focus:ring-primary-500/20 
                     active:transform active:scale-[0.98]"
          onClick={() => {
            if (import.meta.env.DEV) console.debug("navigate to /U2101");
            navigate("/");
          }}
        >
          Retour à l'Accueil
        </button>
      </div>
    </div>
  );
};

export default U2000NotFound;
